module.exports = __webpack_public_path__ + "img/poc-status.2b887537.png";